import { createFileRoute } from "@tanstack/react-router";

import { Footer } from "@/components/Footer/Footer";
import { MyBookings } from "@/features/bookings/components/MyBookings";
import { ReservationType } from "@/features/bookings/types/types";
import type { SearchScope } from "@/types/types";
import { Feature, isFeatureDisabled } from "@/utils/featureFlags";

const defaultCategory: SearchScope = "flights";

export const Route = createFileRoute("/_authenticated/bookings")({
  validateSearch: (
    search: Record<string, unknown>,
  ): { category?: SearchScope; reservationType?: ReservationType } => {
    if (isFeatureDisabled(Feature.TripsFlow) && search.category === "trips") {
      return {
        category: undefined,
        reservationType: search.reservationType as ReservationType,
      };
    }

    return {
      category: search.category as SearchScope,
      reservationType: search.reservationType as ReservationType,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const searchParams = Route.useSearch();

  return (
    <main className="main">
      <div className="min-h-full w-full overflow-auto p-4">
        <MyBookings
          category={searchParams.category ?? defaultCategory}
          initReservationType={
            searchParams.reservationType ?? ReservationType.UPCOMING
          }
        />
      </div>

      <Footer />
    </main>
  );
}
